import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { ArrowRight, Scale } from "lucide-react";
import { PageBanner } from "./Attorneys";
import { PRACTICE_AREAS } from "../mock";

const PracticeAreas = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div className="bg-white">
      <PageBanner
        eyebrow="What We Do"
        title="Practice Areas"
      />

      <section className="py-20 md:py-24">
        <div className="container-nw grid lg:grid-cols-12 gap-12">
          {/* Sidebar */}
          <aside className="lg:col-span-3">
            <div className="lg:sticky lg:top-32">
              <div className="text-nw-gold text-xs uppercase tracking-[0.3em] mb-4">
                Areas of Practice
              </div>
              <ul className="space-y-1 border-l border-nw-stone">
                {PRACTICE_AREAS.map((p) => (
                  <li key={p.slug}>
                    <a
                      href={`#${p.slug}`}
                      className="block pl-4 py-2 text-sm text-nw-navy/80 hover:text-nw-gold hover:border-l-2 hover:border-nw-gold hover:-ml-px transition-all"
                    >
                      {p.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </aside>

          {/* Content */}
          <div className="lg:col-span-9 space-y-14">
            {PRACTICE_AREAS.map((p, idx) => (
              <article
                key={p.slug}
                id={p.slug}
                className="scroll-mt-32 border-b border-nw-stone pb-14 last:border-b-0"
              >
                <div className="flex items-start gap-5">
                  <div className="hidden sm:flex flex-shrink-0 w-12 h-12 items-center justify-center border border-nw-gold text-nw-gold">
                    <Scale strokeWidth={1.3} className="w-5 h-5" />
                  </div>
                  <div className="flex-1">
                    <div className="text-nw-gold text-xs uppercase tracking-[0.3em] mb-2">
                      {String(idx + 1).padStart(2, "0")} — Practice Area
                    </div>
                    <h2 className="font-serif-display text-3xl md:text-4xl text-nw-navy">
                      {p.title}
                    </h2>
                    <div className="h-0.5 w-12 bg-nw-gold mt-4 mb-5" />
                    <p className="text-nw-navy/80 leading-relaxed text-base md:text-[17px]">
                      {p.long}
                    </p>
                    <Link
                      to="/contact"
                      className="inline-flex items-center gap-2 mt-5 text-nw-navy hover:text-nw-gold text-xs font-bold uppercase tracking-[0.15em] link-underline"
                    >
                      Discuss Your Matter <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PracticeAreas;
